import React from 'react';
import { useDispatch } from 'react-redux';
import { resetPlayers } from '../../../store/slice/createTeamSlice';
import FormationPlayerCard from '../formationPlayerCard';
import PlayerSkillIcon from '../playerSkillIcon';
import Button from '../button';
import { IMG_BASE_PATH } from 'utils/constants';
import TotalPoints from '../totalPoints';

const PickedPlayer = ({
  onViewPicks,
  selectedPlayer,
  title,
  handleButtonClick,
  variant,
  editAccess,
  matchStstus,
  totalPoints,
  forceDefaultImage,
  isDisabled,
  playerIdsForGameday,
  img,
  lateOnboard
}) => {
  const batter =
    selectedPlayer?.find((player) => player?.skill_id === 1) ||
    img?.find((player) => player?.skill_id === 1);
  const bowler =
    selectedPlayer?.find((player) => player?.skill_id === 2) ||
    img?.find((player) => player?.skill_id === 2);
  const allRounder =
    selectedPlayer?.find((player) => player?.skill_id === 3) ||
    img?.find((player) => player?.skill_id === 3);

  return (
    <div className='si-matchCard-foot__playerWrap'>
      <div className='si-matchCard-foot__grid'>
        <div className='si-matchCard-foot__gridLhs'>
          <div className='si-matchCardSkill__list'>
            <div className='si-matchCardSkill__list-item'>
              <FormationPlayerCard
                thumbnail={batter ? batter.id : 0}
                fallback={`${IMG_BASE_PATH}images/players/2.png`}
              />

              <PlayerSkillIcon skillType={1} />
            </div>
            <div className='si-matchCardSkill__list-item'>
              <FormationPlayerCard
                thumbnail={bowler ? bowler.id : 0}
                fallback={`${IMG_BASE_PATH}images/players/2.png`}
              />
              <PlayerSkillIcon skillType={2} />
            </div>
            <div className='si-matchCardSkill__list-item'>
              <FormationPlayerCard
                thumbnail={allRounder ? allRounder.id : 0}
                fallback={`${IMG_BASE_PATH}images/players/2.png`}
              />
              <PlayerSkillIcon skillType={3} />
            </div>
          </div>
        </div>
        {matchStstus == 4 || matchStstus == 3 ? (
          <TotalPoints
            totalPoints={totalPoints}
            addCls={'si-totalPoints__wrap--cta'}
            hideIcon={true}
            onClick={handleButtonClick}
            lateOnboard={lateOnboard}
          />
        ) : (
          <div className='si-matchCard-foot__gridRhs'>
            <Button variant={variant} disabled={isDisabled} onClick={handleButtonClick}>
              {title}
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default PickedPlayer;
